var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reg-icon"},[_c('img',{attrs:{"src":_vm.svg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }